import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
  SvgIcon,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

const StyledTypography = styled(Typography)(({ theme }) => ({
  padding: '0 65px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    padding: '0',
  },
}));

const StyledDialogActions = styled(DialogActions)`
  justify-content: center;
  gap: 1em;
  padding: 0 0 24px 0;
`;

const NotesTitle = styled(Typography)`
  display: flex;
  gap: 0.3rem;
  font-weight: 500;
`;

const StyledRequiredField = styled('sup')`
  color: #ff3e3e;
  font-size: 16px;
`;

const StyledDialogContent = styled(Stack)`
  padding: 8px 0px 0px;
  gap: 8px;
`;

export default function ConfirmationDialog({
  open,
  onClose,
  onSave,
  isLoading = false,
  icon = null,
  iconColor = 'warning',
  title,
  description,
  showNotesField = false,
  notesRequired = false,
  notesTitle = '',
  yesLabel = 'Yes',
  noLabel = 'No',
}) {
  const [comments, setComments] = useState('');

  const handleSave = () => {
    if (showNotesField) {
      onSave({ comments });
    } else {
      onSave();
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent>
        <Grid container direction={'column'} alignItems="center">
          {icon && (
            <Grid item>
              <SvgIcon
                color={iconColor}
                sx={{ fontSize: '72px' }}
                component={icon}
              />
            </Grid>
          )}
          <Stack textAlign="center" gap={1}>
            <Typography variant="h4">{title}</Typography>
            <StyledTypography variant="subtitle1" color="text.secondary">
              {description}
            </StyledTypography>
          </Stack>
        </Grid>

        {showNotesField && (
          <StyledDialogContent>
            <Stack gap={2}>
              <Stack gap={1}>
                <NotesTitle>
                  {notesTitle}
                  {notesRequired && (
                    <StyledRequiredField>*</StyledRequiredField>
                  )}
                </NotesTitle>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  size="small"
                  value={comments}
                  onChange={e => setComments(e.target.value)}
                  inputProps={{ 'data-testid': 'comments' }}
                />
              </Stack>
            </Stack>
          </StyledDialogContent>
        )}
      </DialogContent>

      <StyledDialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            color: 'black',
            borderColor: 'lightgray',
            '&:hover': {
              backgroundColor: 'lightgray',
              borderColor: 'lightgray',
            },
          }}
        >
          {noLabel}
        </Button>
        <LoadingButton
          color="primary"
          variant="contained"
          loading={isLoading}
          onClick={handleSave}
          disabled={notesRequired && showNotesField && !comments}
        >
          {yesLabel}
        </LoadingButton>
      </StyledDialogActions>
    </Dialog>
  );
}
